import React from 'react';
import {
    Box,
    TextField,
    Typography,
    Paper,
    Button,
    IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const BasicInfoStep = ({ 
    packageData,
    onFieldChange,
    errors = {}
}) => {
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            onFieldChange('packageImage', file);
        }
    };

    const handleDeleteImage = () => {
        onFieldChange('packageImage', null);
    };

    return (
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h6" gutterBottom>
                Basic Package Information
            </Typography>
            
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    fullWidth
                    label="Package Name"
                    value={packageData.packageName || ''}
                    onChange={(e) => onFieldChange('packageName', e.target.value)}
                    error={!!errors.packageName}
                    helperText={errors.packageName}
                    required
                />

                <TextField
                    fullWidth
                    label="Package Description"
                    value={packageData.packageDescription || ''}
                    onChange={(e) => onFieldChange('packageDescription', e.target.value)}
                    error={!!errors.packageDescription}
                    helperText={errors.packageDescription}
                    required
                    multiline
                    rows={4}
                />

                <Box>
                    <Typography variant="subtitle1" gutterBottom>
                        Package Image*
                    </Typography>
                    
                    {!packageData.packageImage ? (
                        <>
                            <input
                                accept="image/*"
                                style={{ display: 'none' }}
                                id={`package-image-upload-${packageData.id}`}
                                type="file"
                                onChange={handleImageChange}
                            />
                            <label htmlFor={`package-image-upload-${packageData.id}`}>
                                <Button variant="outlined" component="span">
                                    Upload Image
                                </Button>
                            </label>
                        </>
                    ) : (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                            <Box sx={{ mt: 2 }}>
                                <img 
                                    src={URL.createObjectURL(packageData.packageImage)}
                                    alt="Package preview"
                                    style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }}
                                />
                            </Box>
                            <IconButton 
                                color="error" 
                                onClick={handleDeleteImage}
                                sx={{ mt: 2 }}
                                aria-label="delete image"
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    )}
                    
                    {errors.packageImage && (
                        <Typography color="error" variant="caption" display="block" sx={{ mt: 1 }}>
                            {errors.packageImage}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Paper>
    );
};

export default BasicInfoStep; 